import store from '@/store';
import { showTextModal } from '@/common/utils/ModalState';

// 260625: AI 생성 유료화 — flag off면 준비중 모달 + 차단(rule 55, fail-closed). 딥링크/뒤로가기 우회 차단.
const requireAiGenFlag = async (to, from) => {
  await store.dispatch('common/fetchFeatureFlags', { force: true });
  const flags = store.getters['common/getFeatureFlags'];
  if (!flags?.aiCreativeGenerateEnabled) {
    showTextModal('AI 생성 기능은 현재 준비중이에요.\n곧 만나뵐게요.', '확인');
    return from?.name ? false : '/main';
  }
};

export default [
  {
    path: '/flyer/create',
    component: () => import('@/views/flyer/FlyerCreate.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: 'AI 전단지 만들기'
    },
    beforeEnter: async (to, from) => {
      const blocked = await requireAiGenFlag(to, from);
      if (blocked !== undefined) return blocked;
    }
  },
  {
    path: '/flyer/my',
    component: () => import('@/views/flyer/MyFlyers.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '내 전단지'
    }
  },
  {
    path: '/flyer/send/:fileNo',
    component: () => import('@/views/flyer/FlyerSend.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '전단지 발송'
    }
  },
  {
    // 260622 P2: 소비자 '내 서랍'(받은 전단지). 마이페이지 진입.
    path: '/drawer',
    component: () => import('@/views/flyer/Drawer.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '내 서랍'
    }
  },
  {
    // 260622 P2: 내 위치 설정(반경 전단지 수신용 좌표 저장).
    path: '/more/my-location',
    component: () => import('@/views/flyer/MyLocation.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '내 위치 설정'
    }
  }
];
